import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { LineGraphReadingsDataDto } from '../../../data/models/line-graph-data-dto';
import { TotalGraphGraphsDto } from '../../../data/models/total-graph-graphs-dto';
import { WanGraphDto } from '../../../data/models/wan-graph-dto';
import { LineGraphService } from '../../../services/line-graph.service';

@Component({
  selector: 'app-total-account-graphs',
  templateUrl: './total-account-graphs.component.html',
  styleUrls: ['./total-account-graphs.component.scss'],
  providers: [MessageService]
})
export class TotalAccountGraphsComponent implements OnInit {
  accountId: number;
  graphs: TotalGraphGraphsDto[] = [];
  selectedGraph: TotalGraphGraphsDto;
  breadItems: MenuItem[];

  totalReadings: LineGraphReadingsDataDto;
  inTraffic: any[] = [];
  outTraffic: any[] = [];
  readingsTime: any[] = [];

  chartOptions = {};
  chart: any;

  showGraph: boolean = false;
  blockUI: boolean = false;

  fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
  toDate: Date = new Date();
  minSelectableDate: Date;
  maxSelectableDate: Date;

  btnDimmed: boolean = true;

  interfacesIds: number[] = [];
  readingList: LineGraphReadingsDataDto;

  constructor(private activatedRoute: ActivatedRoute, private graphService: LineGraphService, private messageService: MessageService) {

    this.minSelectableDate = new Date(new Date().setMonth(new Date().getMonth() - 3));
    this.maxSelectableDate = new Date();
  }

  ngOnInit(): void {
    //check url first to get account id  then
      //send it to BE to get all graphs
        // when select a graph draw it
    this.checkUrlToGetParams();
    this.getTotalGraphs();

    
    this.breadItems =
      [{
        label: 'Home', routerLink:['/']
      },
      {
        label: 'Total Graphs'
      } ]
  }


  checkUrlToGetParams() {
    this.activatedRoute.params.subscribe(
      (params) => {
        let tmpAccountId = params["accountId"];
        if (tmpAccountId) {
          this.accountId = tmpAccountId;
        //  this.getTotalGraphs();
        }
       // else 
        //  this.lineId = 135444;
        //  this.getLineInfo(135444);
        //  //there is no line Id 
        //  this.messageService.add({ severity: 'error', summary: 'Line Id not retrieved', detail: 'unable to show page contents' });
        //}
       // return;
      });
  }


  getTotalGraphs() {
    this.graphService.getAccountGraphs().subscribe((res: TotalGraphGraphsDto[]) => {
      console.log(res);
      this.graphs = res;
    }, (error) => {
       this.messageService.add({ severity: 'error', summary: 'Total Graphs', detail: 'unable to Get totall graphs for this account' });
    });
  }


  onSelectGraph() {
    this.btnDimmed = false;
    this.showGraph = false;
    //featch interfaces ids from selected graph then get its readings
    this.interfacesIds = [];
    this.selectedGraph.childGraphs.forEach(ch => this.interfacesIds.push(ch.graphID));
    if (this.interfacesIds.length > 0) {
      this.getGraphDataReadings(this.interfacesIds);
    }
    else
      this.showGraph = false;

    console.log(this.selectedGraph, this.interfacesIds);
  }

  onUnselectGraph() {
    this.btnDimmed = true;
    this.showGraph = false;

  }

  getGraphDataReadings(interfacesId: number[]) {
    this.graphService.getLineGraphDataReadings(interfacesId, this.fromDate, this.toDate).subscribe((res: LineGraphReadingsDataDto) => {
      console.log(res)
      this.totalReadings = res;
      this.showGraph = true;
      //this.drawChart(this.totalReadings);
    }, (error) => {
      this.showGraph = false;
      this.messageService.add({ severity: 'error', summary: 'Reading Graphs Data', detail: 'unable to Get graph readings' });
    });
  }


  drawLineGraph() {
    console.log(this.selectedGraph);
    this.onSelectGraph();
  }

  //async drawChart(upDownData: LineGraphReadingsDataDto) {
  //  let x: any = this.GetTrafficData(upDownData);
  //  this.destroyChartEvent();
  //  this.chartOptions = {
  //    series: [{
  //      name: 'OutTraffic',
  //      data: x.__zone_symbol__value.outTraffic //this.outTraffic ////
  //    },
  //    {
  //      name: 'Intraffic',
  //      data: x.__zone_symbol__value.inTraffic //this.inTraffic //  //
  //    }],
  //    chart: {
  //      height: 350,
  //      type: "area",
  //      events: {
  //        click: (event, chartContext, config) => {
  //          //this.getGraphStatistics(this.currentSelectedGraph.interfaceId);
  //        }
  //      }
  //    },
  //    colors: ['#068DA9', 'lightgreen'],
  //    dataLabels: {
  //      enabled: false
  //    },
  //    title: {
  //      text: 'xyzxyz'
  //    },
  //    stroke: {
  //      curve: 'smooth',
  //      width: 2,
  //    },
  //    tooltip: {
  //      x: {
  //        show: true,
  //        format: 'dd MMM yyyy  HH:mm',
  //        formatter: undefined,
  //      },
  //      y: {
  //        title: {
  //          formatter: function (value1, value2) {
  //            return;
  //          }
  //        }

  //      }
  //    },
  //    xaxis: {
  //      type: "datetime",
  //      labels: {
  //        datetimeUTC: false,
  //      },
  //      categories: x.__zone_symbol__value.readingTime
  //    },
  //    yaxis: {
  //      labels: {

  //        formatter: function (value, index) {
  //          var val = Math.abs(value);
  //          if (val >= 1000000000) {
  //            value = (value / 1000000000).toFixed(1) + " Gps";
  //          }
  //          else if (val >= 1000000) {
  //            value = (value / 1000000).toFixed(1) + " Mps";
  //          }
  //          else if (val >= 1000 && val < 1000000) {
  //            value = (value / 1000).toFixed(1) + " Kps";
  //          }

  //          else if (val < 1000) {
  //            value = value + " bps";
  //          }
  //          return value;
  //        }
  //      }
  //    },
  //    toolbar: {
  //      show: true,

  //    },

  //  };

  //  this.chart = new ApexCharts(document.querySelector('#graph'), this.chartOptions);
  //  this.chart.render();

  //  this.blockUI = false;
  //}

  //async GetTrafficData(upDownData: LineGraphReadingsDataDto) {
  //  this.inTraffic = [];
  //  this.outTraffic = [];
  //  this.readingsTime = [];

  //  for (var i = 0; i < upDownData.readings?.length; i++) {
  //    this.readingsTime.push((upDownData.readings[i].readingTime));
  //    this.inTraffic.push((upDownData.readings[i].inTraffic));
  //    this.outTraffic.push((upDownData.readings[i].outTraffic));
  //  }
  //  if (upDownData.readings.length == 0) {
  //    this.inTraffic.push[0];
  //    this.outTraffic.push[0];
  //    this.readingsTime.push(this.toDate);

  //  }
  //  let inOutData = { inTraffic: this.inTraffic, outTraffic: this.outTraffic, readingTime: this.readingsTime };
  //  return inOutData;
  //}



  //destroyChartEvent() {
  //  if (this.chart instanceof ApexCharts) {
  //    (<ApexCharts>this.chart).destroy();
  //  }
  //}
}
